import { Alert, Link, Typography } from '@ace-clublabs/shared-component-library';
import { useGlobalState } from '../../state/state';
import { CurrentPayPlan } from '@ace-clublabs/common-membership-api-types';
import { IGetConfirmationResponse } from '@lib/types';
import { getAwsDomainUrl } from '../../utils/generateURL';

export const AutoPayFailedAlert: React.FC = () => {
  const [memberDetails] = useGlobalState('memberDetails');
  const [confirmation] = useGlobalState('confirmation');

  const {
    currentBillPlan,
    updatedBillPlan,
    paymentDetails = {} as IGetConfirmationResponse['paymentDetails'],
  } = confirmation!;
  const { autoPaySuccessful, isAutoPayRequested } = paymentDetails || {};
  const billPlan = updatedBillPlan !== currentBillPlan ? updatedBillPlan : currentBillPlan;
  const enrolledInAutoPay = billPlan !== CurrentPayPlan.RECURRINGMONTHLY && isAutoPayRequested;
  const autoPayFailed = enrolledInAutoPay && !autoPaySuccessful;

  const autoPayLink = `tel:1-800-222-8794`;

  return autoPayFailed ? (
    <Alert severity="error" id="auto-pay-failed-alert" displayCloseButton={false} sx={{ marginTop: '1rem' }}>
      <Typography component="span" variant={'b2Regular'}>
        We couldn't complete your Auto Pay enrollment at this time. To enroll in Auto Pay, please call{' '}
        <Link className="manage-autopay-link" target="_blank" href={autoPayLink}>
          <Typography component="span" variant={'b2Regular'} color="#0156A3">
            1-800-222-8794.
          </Typography>
        </Link>
      </Typography>
    </Alert>
  ) : (
    <></>
  );
};
